import ApiService from './api.service';
import { TokenService } from './storage.service';
import HasMake from '../services/hash.service';
import HashMake from '../services/hash.service';

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.errorCode = errorCode;
    }
}

const UserService = {
    /**
     * Member login the user and store the access token to TokenService. 
     * 
     * @returns access_token
     * @throws AuthenticationError 
    **/
    memberLogin: async function(email, password, language) {
        const requestData = {
            method: 'post',
            url: "member-login",
            data: {
                email: HasMake.encrypt(email),
                password: HasMake.encrypt(password),
                lang: HasMake.encrypt(language)
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        };

        try {
            const response = await ApiService.customRequest(requestData);
            response.data.access_token = response.data.refresh_token = response.data.data.token; //remove after testing 
            localStorage.setItem('userDetails', response.data.data.userDetails);
            TokenService.saveToken(response.data.access_token);
            TokenService.saveRefreshToken(response.data.refresh_token);
            ApiService.setHeader();
            
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            //ApiService.mount401Interceptor();

            return response.data.access_token;
        } catch (error) {            
            throw new AuthenticationError(error.response.data.status, error.response.data);
        }
    },
    /**
     * Login the user and store the access token to TokenService. 
     * 
     * @returns access_token
     * @throws AuthenticationError 
    **/
    login: async function(email, password, language) {
        const requestData = {
            method: 'post',
            url: "login",
            data: {
                email: HasMake.encrypt(email),
                password: HasMake.encrypt(password),
                lang: language
            }
        };

        try {
            const response = await ApiService.customRequest(requestData); 
            TokenService.saveToken(response.data.access_token);
            TokenService.saveRefreshToken(response.data.access_token);
            ApiService.setHeader();

            return response.data.access_token;
        } catch (error) {
            throw new AuthenticationError(error.response.data.status, error.response.data);
        }
    },
    tokenHistory: async function () {
        const response = await ApiService.get('gettokenhistory');
        return response
    },

    fetchUserDetails: async function(){
        return ApiService.get('account').then((userDetailsResponse) => {            
             localStorage.setItem('userDetails', HashMake.encrypt(userDetailsResponse.data.userDetails));
             localStorage.setItem('userDetailsAddress', HashMake.encrypt(userDetailsResponse.data.userAddress));
         });        
     },

    /**
     * Refresh the access token.
    **/
    refreshToken: async function() {
        const refreshToken = TokenService.getRefreshToken();

        const requestData = {
            method: 'post',
            url: "/o/token/",
            data: {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            },
            auth: {
                username: process.env.VUE_APP_CLIENT_ID,
                password: process.env.VUE_APP_CLIENT_SECRET
            }
        };

        try {
            const response = await ApiService.customRequest(requestData);

            TokenService.saveToken(response.data.access_token);
            TokenService.saveRefreshToken(response.data.refresh_token);
            // Update the header in ApiService
            ApiService.setHeader();

            return response.data.access_token;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail);
        }

    },

    /**
     * Logout the current user by removing the token from storage. 
     * 
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well 
        ApiService.post('logout',{});
        this.clearUserSessionData();        
        ApiService.removeHeader();
        
        // NOTE: Again, we'll cover the 401 Interceptor a bit later. 
        //ApiService.unmount401Interceptor()
    },

    clearUserSessionData() {
        TokenService.removeToken();
        TokenService.removeUserDetails();
        TokenService.removeRefreshToken();
        TokenService.removeVirtualUserDetails();
        TokenService.removePrevUrl();
        TokenService.removeUserDetailsAddress();
    }    
};

export default UserService;

export { UserService, AuthenticationError };